import React, { Component } from "react";
import PropTypes from "prop-types";

import "./CtTimer.css";

export default class CtTimer extends Component {
  static propTypes = {
    ends: PropTypes.number
  };

  state = {
    days: "0",
    hours: "0",
    minutes: "0",
    seconds: "0"
  };

  getTime = () => {
    const now = Date.now();
    const diff = now <= this.props.ends ? this.props.ends - now : 0;

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    this.setState({
      days,
      hours: hours % 24,
      minutes: minutes % 60,
      seconds: seconds % 60
    });
  };

  componentWillMount() {
    this.timer = setInterval(() => {
      this.getTime();
    }, 1000);
  }

  componentWillUnmount = () => {
    clearInterval(this.timer);
  };

  render() {
    return (
      <div className="CtTimer">
        <table className="counter-style">
          <tbody>
            <tr className="timer">
              <td className="days tdd">{this.state.days}</td>
              <td className="hours tdd">{this.state.hours}</td>
              <td className="minutes tdd">{this.state.minutes}</td>
              <td className="seconds tdd">{this.state.seconds}</td>
            </tr>

            <tr className="text">
              <td className="tdd">Days</td>
              <td className="tdd">Hours</td>
              <td className="tdd">Minutes</td>
              <td className="text-seconds tdd">Seconds</td>
            </tr>
          </tbody>
        </table>

        {/* {`${this.state.hour} : ${this.state.minutes} : ${this.state.seconds}`} */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ct-timer/CtTimer.js